import { Flex, Stack, StackProps } from '@chakra-ui/react'
import { AmexLogo } from 'components/svg/AmexLogo'
import { GoogleSafeBrowsingIcon } from 'components/svg/GoogleSafeBrowsingIcon'
import { IuguLogo } from 'components/svg/IuguLogo'
import { MastercardLogo } from 'components/svg/MastercardLogo'
import { SslSecureLogo } from 'components/svg/SslSecureLogo'
import { VisaLogo } from 'components/svg/VisaLogo'
import { Body1 } from 'components/typography'
import { FC } from 'react'

export const SafeEnvironmentSection: FC<StackProps> = (props) => {
  return (
    <Stack {...props}>
      <Body1 color="magicmint" pb="4px" borderBottom="2px solid #153F48">
        Ambiente protegido
      </Body1>
      <Flex
        wrap="wrap"
        gap={{ base: '0.5rem', lg: '2rem' }}
        py="4"
        align="center"
        justifyContent={{ base: 'space-between', lg: 'normal' }}
      >
        <SslSecureLogo theme={'phthalo'} width="40px" height="26px" />
        <MastercardLogo theme={'phthalo'} width="38px" height="24px" />
        <IuguLogo fill="magicmint" />
        <VisaLogo theme={'phthalo'} width="50px" height="20px" />
        <GoogleSafeBrowsingIcon theme={'phthalo'} width="20px" height="26px" />
        <AmexLogo theme={'phthalo'} width="60px" height="20px" />
      </Flex>
    </Stack>
  )
}
